import { BaseObject } from './BaseObject';
import { SVGRenderer } from '../core/SVGRenderer';
import { Point2D } from '../types';

export class Circle extends BaseObject {
  public center: Point2D;
  public radius: number;
  public isConstruction: boolean;
  public circleElem: SVGCircleElement | null = null;
  public drawProgress: number = 0.0;

  constructor(
    renderer: SVGRenderer,
    center: Point2D,
    radius: number,
    isConstruction: boolean = true,
    id?: string
  ) {
    super(renderer, id);
    this.center = { ...center };
    this.radius = radius;
    this.isConstruction = isConstruction;
    this.color = isConstruction ? renderer.config.constructionColor : renderer.config.lineColor;
    this.strokeWidth = isConstruction ? 1.5 : 2.5;
    this.render();
  }

  public render(): SVGElement {
    const circumference = 2 * Math.PI * this.radius;

    this.circleElem = this.renderer.createElement('circle', {
      id: this.id,
      cx: this.center.x,
      cy: this.center.y,
      r: this.radius,
      fill: 'none',
      stroke: this.color,
      'stroke-width': this.strokeWidth,
      'stroke-dasharray': `${circumference}`,
      'stroke-dashoffset': `${circumference * (1 - this.drawProgress)}`,
    });

    if (this.isConstruction) {
      this.renderer.layers.constructions.appendChild(this.circleElem);
    } else {
      this.renderer.layers.objects.appendChild(this.circleElem);
    }

    this.element = this.circleElem;
    return this.circleElem;
  }

  public setDrawProgress(progress: number): void {
    this.drawProgress = Math.max(0, Math.min(1, progress));
    this.update();
  }

  public update(): void {
    if (!this.circleElem) return;
    const circumference = 2 * Math.PI * this.radius;

    this.circleElem.setAttribute('cx', String(this.center.x));
    this.circleElem.setAttribute('cy', String(this.center.y));
    this.circleElem.setAttribute('r', String(this.radius));
    this.circleElem.setAttribute('stroke', this.color);
    this.circleElem.setAttribute('stroke-dasharray', `${circumference}`);
    this.circleElem.setAttribute('stroke-dashoffset', `${circumference * (1 - this.drawProgress)}`);
  }
}
